// extracted by mini-css-extract-plugin
export default {"mainCenter":"PolitikaPrivatnosti_mainCenter__UJZ26"};